import React from 'react'
import BackgroundVid from '../components/BackgroundVid';
import {Link} from 'react-router';

import DownArrow from '../components/downArrow';
import SignupModal from '../components/SignupModal';


export default class HomeFirst extends React.Component {

	constructor(props) {
		super(props);
		this.state= {
		 	showSignup: false,
		};
	}

	handleOpenSignup(){
		  this.setState({showSignup: true});
		};

	handleCloseSignup(){
	  this.setState({showSignup: false});
	};

	render(){

		return (
			<div id="home_first" className="home_first hide_overflow">
				<BackgroundVid></BackgroundVid>

				<div className="middle_main">
				  <h1>Outperforming the market
					<br/>is our business</h1>
				  <p>A new investing dynamic</p>
				  <br/>
				  {
						// <a onTouchTap={this.handleOpenSignup.bind(this)} className="btn tipigo-vp-btn btn-raised btn-success">VIEW PERFORMANCE</a>
					}

					 <Link to="contact_us" className="btn tipigo-vp-btn btn-raised btn-success">CONTACT US</Link>
			    </div>
			    <DownArrow elementId="home_first"></DownArrow>
			    <SignupModal handleClose={this.handleCloseSignup.bind(this)} open={this.state.showSignup}></SignupModal>
		    </div>
		    //

		);
	}

}



// WEBPACK FOOTER //
// ./src/js/components/HomeFirst.js